export default "__VITE_ASSET__6d387b02__"